module.exports = __webpack_public_path__ + "img/help_chrome3,4.ec3b7979.png";